// noinspection JSUnusedGlobalSymbols

export enum RequestTypes {
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE",
    GET = "GET"
}
